export default "__VITE_ASSET__f5UI1InW__"